import { createTypes, createAction } from "lib/action";

const LOAD_INSURANCE = createTypes("insurance", "load");
const LOAD_VEHICLE_INSURANCE = createTypes(
  "vehicle_insurance",
  "load"
);
const LOAD_VEHICLE_TYPE_INSURANCE = createTypes("vehicletype_insurance", "load");

const loadInsurance = {
  request: (data, loading) =>
    createAction(LOAD_INSURANCE.REQUEST, { data, loading }),
  success: data => createAction(LOAD_INSURANCE.SUCCESS, { data }),
  failure: () => createAction(LOAD_INSURANCE.FAILURE)
};

const loadVehicle = {
  request: (vehicletypeID, loading_vehicle) =>
    createAction(LOAD_VEHICLE_INSURANCE.REQUEST, {
      vehicletypeID,
      loading_vehicle
    }),
  success: data =>
    createAction(LOAD_VEHICLE_INSURANCE.SUCCESS, { data }),
  failure: () => createAction(LOAD_VEHICLE_INSURANCE.FAILURE)
};

const loadVehicleType = {
  request: () => createAction(LOAD_VEHICLE_TYPE_INSURANCE.REQUEST, {}),
  success: data => createAction(LOAD_VEHICLE_TYPE_INSURANCE.SUCCESS, { data }),
  failure: () => createAction(LOAD_VEHICLE_TYPE_INSURANCE.FAILURE)
};

export {
  loadInsurance,
  LOAD_INSURANCE,
  loadVehicle,
  LOAD_VEHICLE_INSURANCE,
  loadVehicleType,
  LOAD_VEHICLE_TYPE_INSURANCE
};
